export const Colors = {
  MNBlue: "#8eacff",
  MNPurple: "#2d1c3f",
  MNGreen: "#64bca4",
  MNBlack: "#161020",
  MNGrey: "#b1b0b5",
};
